import React, { useState } from 'react';
import { SearchResult } from './';
import { ResultSection } from './ResultSection';

export function ResultList({ results, isDisabled, onEntityClick }) {
  const [showEvents, setShowEvents] = useState(true);
  const [showLocations, setShowLocations] = useState(true);
  const [showArticles, setShowArticles] = useState(true);

  const handleToggleSection = (section) => {
    switch (section) {
      case 'Events':
        setShowEvents((prev) => !prev);
        break;
      case 'Locations':
        setShowLocations((prev) => !prev);
        break;
      case 'Articles':
        setShowArticles((prev) => !prev);
        break;
      default:
        break;
    }
  };
  if (!results || isDisabled) return null;
  const { articles, events, locations } = results;
  const isEmpty =
    (!articles || articles.length === 0) &&
    (!events || events.length === 0) &&
    (!locations || locations.length === 0);

  console.log('Results List: ', results);
  //...return null if there's no results in the entities.
  return (
    <div className="chronos-global-search-results">
      {isEmpty && <NoResults />}
      {!isEmpty && (
        <React.Fragment>
          {locations && locations.length > 0 && (
            <React.Fragment>
              <ResultSection
                icon="far fa-pin fa-fw"
                label="Locations"
                isOpen={showLocations}
                onToggle={handleToggleSection}
              />
              {showLocations &&
                locations.map((location) => (
                  <SearchResult
                    isEntity
                    key={location._id}
                    result={location}
                    type="location"
                    onSelect={onEntityClick}
                  />
                ))}
            </React.Fragment>
          )}
          {events && events.length > 0 && (
            <React.Fragment>
              <ResultSection
                icon="far fa-sparkles fa-fw"
                label="Events"
                isOpen={showEvents}
                onToggle={handleToggleSection}
              />
              {showEvents &&
                events.map((event) => (
                  <SearchResult
                    isEntity
                    key={event._id}
                    result={event}
                    type="event"
                    onSelect={onEntityClick}
                  />
                ))}
            </React.Fragment>
          )}
          {articles && articles.length > 0 && (
            <React.Fragment>
              <ResultSection
                icon="far fa-file fa-fw"
                label="Articles"
                isOpen={showArticles}
                onToggle={handleToggleSection}
              />
              {showArticles &&
                articles.map((article) => (
                  <SearchResult
                    isArticle
                    key={article.id}
                    result={article}
                    type="article"
                    onSelect={onEntityClick}
                  />
                ))}
            </React.Fragment>
          )}
        </React.Fragment>
      )}
    </div>
  );
}

function NoResults() {
  return (
    <div className="chronos-global-search-result chronos-global-search-no_results">
      <h3 className="chronos-no_result-title">No Results Found.</h3>
    </div>
  );
}
